export default __webpack_public_path__ + "assets/png/79c49facff8b68c276298cb279ad8649.png";